import React from 'react'
import { message } from 'antd'
import CollectGroupBtn from 'component/collectGroupBtn'
import Icon from 'meinian-package/src/component/icon'
import request from 'meinian-package/src//utils/request'
import { cdnImg } from 'meinian-package/src/utils/image'
import LazyLoadImage from 'meinian-package/src/baseComponent/lazyLoadImage'
import './recommendImage.less'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import { BatchItem } from '../batch'
import { formatTime } from '../util'

const RecommendImage = (props) => {
  const {
    data = [], picUrl, aggCollection, saleTime, shopName, title, cPrice, sale30day, totalSaleVolume, collect, commentCount, itemId,
    isBatch, outerIndex, columnWidth, onDeleteItem, initWaterfall
  } = props

  return <div style={{ width: columnWidth, height: columnWidth + 176 }}>
    <div className="meinian-recommend-card" onClick={() => window.open(`/itemDetail/overview/base?itemId=${JSON.stringify(itemId)}`)}>
      <div className="meinian-recommend-card-warp">
        <LazyLoadImage className="meinian-recommend-card-image" src={cdnImg(picUrl, 500)} />
        {
          isBatch ? null : <div className="recommend-image-shadow">
            <CollectGroupBtn
              currentBlog={{ itemId }}
              onCollectClick={() => {
                request.post('/zhikuan/inspiration/recommend/save-user-option-record', { interestStatus: 1, itemId })
                request.track({ code: 6400037, type: '今日推荐-采集' })
              }}
            />
            <Uninterest
              {...props}
              itemId={itemId}
              className="recommend-image-shadow-uninterest"
              onChange={() => {
                onDeleteItem(data[outerIndex])
                initWaterfall && initWaterfall()
                props?.onResize()
              }}
            />
          </div>
        }
      </div>
      {isBatch ? <div className="batch-mask"><BatchItem keyValue={itemId} className="batch-check" info={data[outerIndex]} /></div>
        : ''}

      <div className="meinian-recommend-infor-wrapper">
        <div className="meinian-recommend-infor-title line-1">{title}</div>
        <div style={{ marginBottom: '12px' }}>
          <span className="meinian-recommend-infor-price">￥{(cPrice / 100).toFixed(2)}</span>
          <span className="meinian-recommend-infor-date">{formatTime(saleTime, 'YYYY/MM/DD')}上架</span>
        </div>
        <div className="meinian-recommend-infor-shop">{shopName}</div>
        <div style={{ marginBottom: '4px' }}>
          <span className="meinian-recommend-infor-sales">月销量{sale30day}</span>
          <span className="meinian-recommend-infor-collection">本期收藏量{aggCollection}</span>
        </div>
      </div>
      <div className="meinian-recommend-infor-evaluate">
        <div className="meinian-recommend-infor">销量 {totalSaleVolume}</div>
        <div className="meinian-recommend-infor">收藏 {collect}</div>
        <div className="meinian-recommend-infor">评价 {commentCount}</div>
      </div>
    </div>
  </div>
}

const Uninterest = (props) => {
  const { className, itemId, onChange } = props

  const onClick = () => {
    message.success('我们将尽快为你减少相关内容的推荐~')
    request.post('/zhikuan/inspiration/recommend/save-user-option-record', {
      interestStatus: 0,
      itemId
    })
    onChange(itemId)
  }
  return <div className={className}>
    <Tooltip placement="bottom" title="不感兴趣">
      <span style={{ display: 'block', width: '24px', height: '24px', background: '#FFFFFF' }} onClick={(e) => { e && e.stopPropagation(); onClick() }}>
        <Icon type="mnic_unlike_24px" style={{ fontSize: '24px' }} />
      </span>
    </Tooltip></div>
}
export default RecommendImage
